<ng-template #content let-modal>

    <div *ngIf="loader === 'content'">
        <div class="modal-header">
            <h3 class="header-title m-0 p-0">Customer feedback</h3>
            <app-general-button
                    [btnStyle]="'Outline'"
                    [btnAction]="'Close'"
                    [btnType]="'Short'"
                    (click)="modal.close('Close click'); this.message = ''; this.subject = ''">
            </app-general-button>
        </div>

        <div class="modal-body">
            <form (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="subject">Subject</label>
                    <input [(ngModel)]="subject" name="subject" type="text" class="form-control" ngModel id="subject"
                           placeholder="Enter title">
                </div>
                <div class="form-group">
                    <label for="message">Message</label>
                    <textarea [(ngModel)]='message'
                              name="message"
                              class="form-control input-text"
                              id="message"
                              rows="3"
                              ngModel placeholder='Enter content'>
                </textarea>
                </div>
            </form>
        </div>

        <div class="modal-footer">
            <app-general-button
                    [btnStyle]="'Solid'"
                    [btnType]="'Long'"
                    [btnAction]="'Custom'"
                    [textOnly]="false"
                    [text]="'Submit'"
                    [icon]="'fa fa-paper-plane'"
                    [color]="'green'"
                    (click)="onSubmit()">
            </app-general-button>
        </div>
    </div>

    <!--Invalid Message-->
    <div *ngIf="loader === 'invalid'">
        <div class="modal-body">
            <div class="d-flex justify-content-center align-items-center flex-column loading-modal w-100 h-100">
                <i [ngClass]="{'red' : loader === 'invalid'}" class="fa fa-times"></i>
                <h3 class="font-weight-bolder">Feedback not sent!</h3>
                <span *ngIf="subject === '' && message !== ''">Please add a subject.</span>
                <span *ngIf="message === '' && subject !== ''">Please add a message.</span>
                <span *ngIf="message === '' && subject === ''">Please add text to your feedback.</span>
            </div>
        </div>
        <div class="modal-footer">
            <app-general-button
                    [btnStyle]="'Solid'"
                    [btnType]="'Long'"
                    [btnAction]="'Back'"
                    (click)="this.loader = 'content'">
            </app-general-button>
        </div>
    </div>

    <!--Valid Message-->
    <div *ngIf="loader === 'valid'">
        <div class="modal-body">
            <div class="d-flex justify-content-center align-items-center flex-column loading-modal">
                <i [ngClass]="{'green' : loader === 'valid'}" class="fa fa-check"></i>
                <div class="d-flex justify-content-center align-items-center flex-column">
                    <h3 class="font-weight-bolder">Feedback sent successfully!</h3>
                    <span>We greatly appreciate your help.</span>
                </div>
                <span class="mt-5">This will close in a few seconds.</span>
            </div>
        </div>
    </div>

    <!--Error Message-->
    <div *ngIf="loader === 'error'">
        <div class="modal-body">
            <div class="d-flex justify-content-center align-items-center flex-column loading-modal">
                <i [ngClass]="{'red' : loader === 'error'}" class="fa fa-exclamation-triangle"></i>
                <div class="d-flex justify-content-center align-items-center flex-column">
                    <h3 class="font-weight-bolder">Something went wrong!</h3>
                    <span>We apologise, the feedback aren't working at the moment.</span>
                </div>
            </div>
        </div>
    </div>

</ng-template>

<app-general-button
        [btnStyle]="'Solid'"
        [btnType]="'Long'"
        [btnAction]="'Custom'"
        [textOnly]="false"
        [text]="'Feedback'"
        [icon]="'far fa-question-circle'"
        [color]="'tint-main'"
        (click)="openVerticallyCentered(content)">
</app-general-button>
